import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
   providedIn: 'root',
})
export class ApiService {
   private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
   constructor(private http: HttpClient) {}

   private getApiBaseUrl(): string {
      const baseUrl = environment.apiBaseUrl.endsWith('/') ? environment.apiBaseUrl : `${environment.apiBaseUrl}/`;
      const apiPathPrefix = (environment.apiPathPrefix || 'api').replace(/^\/+|\/+$/g, '');

      return `${baseUrl}${apiPathPrefix}/`;
   }

   get(domain: string, param?: any): Observable<any> {
      let url = this.getApiBaseUrl() + domain;
      if (param) {
         url += '/' + param;
      }

      return this.http.get(url, { headers: this.headers });
   }

   post(domain: string, data: any): Observable<any> {
      const url = this.getApiBaseUrl() + domain;

      return this.http.post(url, JSON.stringify(data), { headers: this.headers });
   }

   put(domain: string, data: any): Observable<any> {
      const url = this.getApiBaseUrl() + domain;

      return this.http.put(url, JSON.stringify(data), {
         headers: this.headers,
         observe: 'response',
      });
   }

   delete(domain: string, guid: string): Observable<any> {
      const url = this.getApiBaseUrl() + domain + '/' + guid;

      return this.http.delete(url, { headers: this.headers });
   }
}
